const setOtherTitle = (val = null) => {
  return {
    type: 'SET_OTHERTITLE',
    data: val,
  }
}

export default {
  setOtherTitle,
}
